function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0.753811H60V60.7808H0V0.753811Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_64_313)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.6562 43.8412C28.9507 45.1395 31.0493 45.1395 32.3438 43.8412",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.0582 27.4482C22.0582 26.5565 21.336 25.8337 20.4451 25.8337C19.5543 25.8337 18.832 26.5565 18.832 27.4482",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.9414 27.4482C37.9414 26.5565 38.6636 25.8337 39.5545 25.8337C40.4454 25.8337 41.1676 26.5565 41.1676 27.4482",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.105 28.8384C56.185 27.4496 59.1203 23.5838 59.1203 19.0321V11.0209C59.1203 9.72601 58.0711 8.67613 56.7766 8.67613H48.7691C44.4153 8.67613 40.6895 11.3653 39.1602 15.1737",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.8338 15.1609C19.3445 11.4667 15.7869 8.82927 11.5963 8.68342L10.4047 8.67615H3.22266C1.9282 8.67615 0.878906 9.72615 0.878906 11.021V19.0322C0.878906 23.5748 3.80238 27.4342 7.86973 28.8301",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.97914 24.5513C7.44695 23.9662 5.57031 21.6448 5.57031 18.9305V13.3707H11.1277C13.7382 13.3707 15.9851 15.1089 16.6722 17.497",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.0532 24.5435C52.568 23.9454 54.4278 21.6327 54.4278 18.9307V13.3708H48.8705C46.2677 13.3708 44.0262 15.0988 43.332 17.4762",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.25 43.0306C11.9236 49.1609 20.9613 52.594 29.9991 52.8589C41.7302 52.5151 53.4614 46.8332 53.4614 36.8437C53.4614 31.2413 51.4997 26.0975 48.2261 22.0621",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.8147 19.5029C41.6437 15.6937 36.0937 13.3706 30.0014 13.3706C17.0435 13.3706 6.53906 23.8798 6.53906 36.8435C6.53906 37.8536 6.65906 38.8198 6.88688 39.7407",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.9676 34.3011C37.9676 37.5176 34.401 40.125 30.0013 40.125C25.6018 40.125 22.0352 37.5176 22.0352 34.3011C22.0352 31.0846 25.6018 28.4772 30.0013 28.4772C34.401 28.4772 37.9676 31.0846 37.9676 34.3011Z",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.0715 32.3528L27.0703 33.8882",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.9309 32.3688L32.9297 33.9043",
  stroke: "black",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgPigs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_64_313",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 61
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPigs);
export default __webpack_public_path__ + "static/media/pigs.d99fef0800e6cfb24edb19d105888af7.svg";
export { ForwardRef as ReactComponent };